import { render, staticRenderFns } from "./CallRightSidebar.vue?vue&type=template&id=126c136e&scoped=true&"
import script from "./CallRightSidebar.vue?vue&type=script&lang=js&"
export * from "./CallRightSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CallRightSidebar.vue?vue&type=style&index=0&id=126c136e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126c136e",
  null
  
)

export default component.exports